import React, { useState, useRef, useMemo } from "react";

/* Nominatim */
import Geolookup from 'react-geolookup';
// IMPORTANT: nomintim-browser is only included in dev dependencies
import * as Nominatim from 'nominatim-browser';


/* OpenStreetMap with leaflet */
import { MapContainer, LayersControl, Marker, TileLayer } from "react-leaflet";
// import { L, Icon } from "leaflet";
import L from "leaflet";
import marker from 'leaflet/dist/images/marker-icon.png';
import marker2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: marker2x,
    iconUrl: marker,
    shadowUrl: markerShadow
});


const AddMarkerFromAddress = ({center, markerChange, composedAddress}) => {

  const [markerlocation, setMarkerLocation] = useState(center);
  const markerRef = useRef(null)


  // const inputEl = useRef(null);
  // const onExternalChange = (composedAddress) => {
  //   inputEl.current.update(composedAddress)
  // };

  // const [address, setAddress] = useState(composedAddress);

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current
        if (marker != null) {
          console.log(marker.getLatLng());
          setMarkerLocation(marker.getLatLng());
          markerChange(marker.getLatLng());
        }
      },
    }),
    [],
  )

  const onSuggestsLookup = (userInput) => {
    console.log(userInput);
    console.log(composedAddress);
    // console.log(bounds);
    const prepend = 'Paderno Dugnano, Milan, Lombardy, ';
    return Nominatim.geocode({
      q: prepend + userInput,
      // q: userInput,
      addressdetails: true
    });
  };

  const onGeocodeSuggest = (suggest) => {
    let geocoded = {};
    if (suggest) {
      console.log(suggest);
      geocoded.nominatim = suggest.raw || {};
      geocoded.location = {
        lat: suggest.raw ? parseFloat(suggest.raw.lat) : '',
        lng: suggest.raw ? parseFloat(suggest.raw.lon) : ''
      };
      geocoded.placeId = suggest.placeId;
      geocoded.isFixture = suggest.isFixture;
      geocoded.label = suggest.raw ? suggest.raw.display_name : '';
      // console.log(geocoded.location);
      setMarkerLocation(geocoded.location);
      markerChange(geocoded.location);
    }

    return geocoded;
  };

  const getSuggestLabel = (suggest) => {
    return suggest.display_name;
    // return suggest.raw.address.road;
  };

  return (
    <div className="row">
      <div className="col-md-4">
        <Geolookup
          // ref={inputEl}
          className="form-row"
          inputClassName="geolookup__input--nominatim form-control"
          buttonText="Cerca"
          placeholder="Indirizzo"
          disableAutoLookup={true}
          onSuggestsLookup={onSuggestsLookup}
          onGeocodeSuggest={onGeocodeSuggest}
          getSuggestLabel={getSuggestLabel}
          country={"it"}
          initialValue={composedAddress}
          // bounds={bounds}
           />
        <small className="form-text text-muted">Cerca l'indirizzo e definisci la posizione precisa dell'esercizio commerciale muovendo il marker sulla mappa.</small>
        {/* <button onClick={inputEl.current.clear()}>Clear</button> */}
      </div>
      <div className="col-md-8">
        <MapContainer center={markerlocation} zoom={13} scrollWheelZoom={false} >
          <LayersControl position="topright">
            <LayersControl.BaseLayer checked name="OpenStreetMap">
              <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Satellite">
              <TileLayer
                attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
              />
            </LayersControl.BaseLayer>
          </LayersControl>

          {/* <MyComponent /> */}

        <Marker
          draggable={true}
          position={markerlocation}
          eventHandlers={eventHandlers}
          ref={markerRef}>
        </Marker>

        </MapContainer>
      </div>
    </div>
  );
};

export default AddMarkerFromAddress;
